
import ImageService from '@/services/ImageService'  
import GLTFService from '@/services/GLTFService' 
 
import AppStore from 'src/store/app'
import { HOME, PATHS } from '@/config/app'
import Env from 'src/config/env'
import AnimationConfig from 'src/config/animation'

import { clamp, map, DEG_TO_RAD } from '@/helpers/MathUtils'
import Pointer from '@/helpers/Pointer'
import EventEmitter from 'src/helpers/EventEmitter'
  
import BaseScene from '@/components/stage/common/base_scene'
import BubbleGroup from '@/components/stage/scene/home/bubble' 
import CameraGroup from '@/components/stage/scene/home/camera'
 
import gsap from 'gsap' 

const THREE = require('three')
import { SkeletonUtils } from 'three/examples/jsm/utils/SkeletonUtils.js'


import vert from '@/components/stage/shaders/base.vert'
import blurPass1_frag from '@/components/stage/shaders/bubble/blurPass1.frag'
import blurPass2_frag from '@/components/stage/shaders/bubble/blurPass2.frag'

const Events = {
  ScrollLock : 'Events.ScrollLock'
}

class Scene extends BaseScene { 

  constructor(config) { 

    super(config) 
    
    this.camera = config.camera
    
    Object.assign(this, EventEmitter)
   
    this.setup()
    this.resize() 
  }

  setup() {   

    this.iFrame = 0

    this.welcomeScale = 1.03
    this.tweenObj = {
      scale: this.welcomeScale,
      pulseAmt: 0
    }

    // let plane = new THREE.Mesh( new THREE.PlaneGeometry(window.innerWidth, window.innerHeight , 32 ), new THREE.MeshBasicMaterial({
    //   color : 0xFFFFFF
    // }))
    // plane.position.z = -1
    // this.add(plane) 


    this.cameraGroup = new CameraGroup({ gui : this.gui, reduced_motion: this.reduced_motion, friction: 0.15   })
    this.add(this.cameraGroup)
    this.views.push(this.cameraGroup)

    this.bubble = new BubbleGroup({
      reduced_motion: this.reduced_motion, 
      material: new THREE.MeshBasicMaterial({ 
        color : 0x545eba,
        blending: THREE.AdditiveBlending 
      }) 
    }) 
    this.bubble.position.z = -0.5
    this.bubble.scale.x = this.bubble.scale.y = this.bubble.scale.z = 1
    this.add( this.bubble )
    this.views.push(this.bubble)


    let geometry = new THREE.CylinderGeometry( 15, 15, 5, 32 );
    this.material = new THREE.MeshBasicMaterial( {color: 0x4046b0, side: THREE.DoubleSide, opacity: 0 , transparent: true } );
    this.cylinder = new THREE.Mesh( geometry, this.material );
    this.cylinder.position.y = 10
    this.add( this.cylinder );


    this.rTexture = new THREE.WebGLRenderTarget(
      window.innerWidth * 0.1,
      window.innerHeight * 0.1,
      {
        minFilter: THREE.LinearFilter ,
        magFilter: THREE.NearestFilter,  
        format: THREE.RGBAFormat 
      }
    );

    this.bufferTexture1 = new THREE.WebGLRenderTarget(
      window.innerWidth * 0.1,
      window.innerHeight * 0.1,
      {
        minFilter: THREE.LinearFilter ,
        magFilter: THREE.NearestFilter,   
        format: THREE.RGBAFormat 
      }
    );

    this.bufferTexture2 = new THREE.WebGLRenderTarget(
      window.innerWidth,
      window.innerHeight,
      {
        minFilter: THREE.LinearFilter ,
        magFilter: THREE.NearestFilter,   
        format: THREE.RGBAFormat  
      }
    ); 


    this.bufferGeo = new THREE.BoxGeometry(1,1,1,4,4,4);
    this.bufferCamera1 = new THREE.OrthographicCamera( -0.5, 0.5, -0.5, 0.5, -3, 50 );
    this.bufferCamera1.position.z = 10;


    // Buffer 1 ///////////////////////////////////
    this.bufferScene1 = new THREE.Scene();
    this.bufferMesh = new THREE.Mesh(this.bufferGeo , this.getBlurPassMaterial(this.rTexture, 0)  );
    this.bufferMesh.scale.x = -1;
    this.materialBlur1 = this.bufferMesh.material;
    this.bufferTexture1 = this.bufferTexture1;
    this.bufferScene1.add(this.bufferMesh);

    // Buffer 2 ///////////////////////////////////
    this.bufferScene2 = new THREE.Scene();
    this.bufferMesh2 = new THREE.Mesh(this.bufferGeo , this.getBlurPassMaterial(this.bufferTexture1, 1)  );
    this.bufferMesh2.scale.x = -1;
    this.materialBlur2 = this.bufferMesh2.material; 
    this.bufferTexture2 = this.bufferTexture2
    this.bufferScene2.add(this.bufferMesh2);
  }

  getBlurPassMaterial(textureRenderTarget, passIndex){

      let frag = (passIndex === 0) ? blurPass1_frag : blurPass2_frag

      let material = new THREE.ShaderMaterial( {
        transparent:true,
        uniforms: {
          blurAmount: { value: 0.13 },
          resolution: { value: [1920.0, 1080.0] },
          tDiffuse1: {value:  textureRenderTarget.texture }
        },
        vertexShader: vert,
        fragmentShader: frag
      } );

      // this.materials.push(material)

      return material
    }

  bubbleLoaded(){ 
    this.bubble.bubbleLoaded() 
  }

  pointerMove(event){   
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].pointerMove(event)
    }
  }

  pointerStart(event){
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].pointerStart(event)
    }   
  }

  pointerEnd(event){
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].pointerEnd(event)
    }
  }


  // UPDATES -------------------------------------------------------------------

 
  tick(delta, time, pulseOpacity) {   
   
    this.bubble.tick(delta, time, pulseOpacity) 
    this.cameraGroup.tick(delta)  

    this.bubble.scale.x = this.bubble.scale.y = this.bubble.scale.z = (this.tweenObj.scale + (pulseOpacity * this.tweenObj.pulseAmt))

    if(this.bufferTexture1){
      
      // render every 3 frames
      this.iFrame++
      //if((this.iFrame % 3) === 1){ 
        this.renderer.setRenderTarget( this.rTexture )
        this.renderer.render( this,  this.cameraGroup.camera)  
   
        this.renderer.setRenderTarget( this.bufferTexture1 )
        this.renderer.render( this.bufferScene1, this.bufferCamera1);

        this.renderer.setRenderTarget(  this.bufferTexture2 )  
        this.renderer.render( this.bufferScene2, this.bufferCamera1);
      //}
    }
 
  }

  resize() { 
    this.bubble.resize() 
    this.rTexture.setSize(window.innerWidth * 0.1, window.innerHeight * 0.1) 
    this.bufferTexture1.setSize(window.innerWidth * 0.1, window.innerHeight * 0.1) 
    this.bufferTexture2.setSize(window.innerWidth , window.innerHeight )  
    this.cameraGroup.resize()
  } 

  destroy(){} 

  enter(){ }

  leave(){ }



  // HANDLERS -------------------------------------------------------------------


  // STATES -------------------------------------------------------------------

  /* modal states */

  /*  
    none
    menu
    video
  */

  /* page states */

 
  transition(dir){ 
 
    const home = AppStore.state.home 
    const isHomeModeDefault = ( home.mode === HOME.MODES.DEFAULT ) 
    if( isHomeModeDefault && !this.reduced_motion ){

      let duration = AnimationConfig.home.section.duration
      switch(dir) {
        case 0:
          // code block
          break;
        case -1:
          gsap.to(this.material, duration * 0.5, { opacity: 0.5, ease: 'power2.in' } )
          gsap.to(this.material, duration * 0.25, { opacity: 0, delay : duration * 0.5, ease: 'expo.out'  } ) 
          gsap.fromTo(this.cylinder.position, duration, { y: 8 }, { y: -8, ease: 'expo.inOut' }) 
          break; 
        case 1:
          gsap.to(this.material, duration * 0.5, { opacity: 0.5, ease: 'power2.in' } )
          gsap.to(this.material, duration * 0.25, { opacity: 0, delay : duration * 0.5, ease: 'expo.out' } ) 
          gsap.fromTo(this.cylinder.position, duration, { y: -8 }, { y: 8, ease: 'expo.inOut' }) 
          break; 
      }
    }  
  }

  setScale(value = 1, ease = 'expo.out', duration = AnimationConfig.home.section.duration) { 
    gsap.to(this.tweenObj, this.getDuration(duration) , { scale: value, delay: AnimationConfig.home.section.duration * 0.5 ,ease: ease  } )
  }

  getDuration(duration){ 
    let clamp = this.reduced_motion ? 0 : 1
    return ( duration * clamp )
  }
  

  /* home states */
 
  welcome(val, prev, dir){ 
    this.views.forEach( view => view.welcome(val, prev) )
    this.transition(dir) 
    this.setScale(this.welcomeScale, 'expo.out')
    gsap.to(this.tweenObj, { duration : 0.5, pulseAmt: 0 })
  } 
 
  ratingFive(val, prev, dir){ 
    this.views.forEach( view => view.ratingFive(val, prev) )
    this.transition(dir)
    this.setScale(1.1, 'expo.out', AnimationConfig.home.section.duration)
    gsap.to(this.tweenObj, { duration : this.getDuration(AnimationConfig.home.section.duration), pulseAmt: 0.05 })
   } 

  ratingFour(val, prev, dir){
    this.views.forEach( view => view.ratingFour(val, prev) )
    this.transition(dir)    
    this.setScale(1.02, 'ease.inOut')
    gsap.to(this.tweenObj, { duration : this.getDuration(AnimationConfig.home.section.duration), pulseAmt: 0.1 })
  } 
 
  ratingThree(val, prev, dir){
    this.views.forEach( view => view.ratingThree(val, prev) )
    this.transition(dir)
    this.setScale(1.15, 'ease.inOut')
    gsap.to(this.tweenObj, { duration : this.getDuration(AnimationConfig.home.section.duration), pulseAmt: 0.15 })
  }

  ratingTwo(val, prev, dir){
    this.views.forEach( view => view.ratingTwo(val, prev) )
    this.transition(dir)
    this.setScale(1.2, 'back.inOut(8)')
    gsap.to(this.tweenObj, { duration : this.getDuration(AnimationConfig.home.section.duration), pulseAmt: 0.2 })
  } 
 
  ratingOne(val, prev, dir){
    this.views.forEach( view => view.ratingOne(val, prev) )
    this.transition(dir)
    this.setScale(1.3, 'back.inOut(8)')
    gsap.to(this.tweenObj, { duration : this.getDuration(AnimationConfig.home.section.duration), pulseAmt: 0.2 })
  } 

  cta(val, prev, dir){
    this.views.forEach( view => view.cta(val, prev) )
    this.transition(dir)
    gsap.to(this.tweenObj, { duration : this.getDuration(AnimationConfig.home.section.duration), pulseAmt: 0 })
  } 
}

export default Scene